import { render, staticRenderFns } from "./WarrantyPdf.vue?vue&type=template&id=1f84fee4&"
import script from "./WarrantyPdf.vue?vue&type=script&lang=js&"
export * from "./WarrantyPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports